export default __webpack_public_path__ + "static/media/Search.0e9388a9.svg";